module.exports = __webpack_public_path__ + "img/day-12.8461e1b2.png";